import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Instagram as InstagramIcon } from '@mui/icons-material';
import { SOCIAL } from '../utils/constants';

// Importe a imagem
import FooterLogo from '../assets/LOGO-FUNDOCINZA.png';

const Footer = () => (
  <Box id="contato" sx={{ bgcolor: '#000', py: 6, borderTop: '1px solid #333', width: '100%', px: { xs: 2, md: 5 } }}>
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: { xs: 'center', md: 'flex-start' },
      textAlign: { xs: 'center', md: 'left' }
    }}>
      
      {/* GRUPO: LOGO + TEXTO (Mobile: Coluna | Desktop: Linha lado a lado) */}
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', md: 'row' }, 
        alignItems: 'center',
        gap: { xs: 2, md: 4 }, // Dá um espaço elegante entre a logo e o texto
        mb: 4 
      }}>
        
        {/* 1. IMAGEM CLICÁVEL */}
        <Box 
          component="a"
          href={SOCIAL.instagram}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ 
            display: 'inline-block', 
            transition: 'transform 0.2s',
            '&:hover': { transform: 'scale(1.05)' } 
          }}
        >
          <Box 
            component="img" 
            src={FooterLogo} 
            alt="Logo Mario Bento"
            sx={{ 
              // Era 80px no md. 3x maior = 240px.
              height: { xs: 200, md: 240 }, 
              width: { xs: 200, md: 240 }, 
              borderRadius: '50%', 
              border: '2px solid #333'
            }} 
          />
        </Box>

        {/* 2. MENSAGEM + ÍCONE CLICÁVEL */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          flexWrap: 'wrap',
          justifyContent: { xs: 'center', md: 'flex-start' }
        }}>
          <Typography variant="h6" color="white" sx={{ mr: 1, fontWeight: 400 }}>
            Acompanhe o meu trabalho no instagram
          </Typography>
          
          <IconButton 
            component="a" 
            href={SOCIAL.instagram}
            target="_blank"
            sx={{ 
              color: '#C13584', 
              p: 0.5,
              '&:hover': { backgroundColor: 'rgba(193, 53, 132, 0.1)' }
            }}
          >
             <InstagramIcon sx={{ fontSize: 32 }} />
          </IconButton>
        </Box>

      </Box> {/* Fim do Grupo Logo + Texto */}
      
      {/* 3. COPYRIGHT */}
      <Typography 
        variant="caption" 
        display="block" 
        sx={{ 
          color: '#555', 
          textAlign: { xs: 'center', md: 'left' },
          width: '100%'
        }}
      >
        © {new Date().getFullYear()} Mario Bento Personal Trainer. Todos os direitos reservados.
      </Typography>
    </Box>
  </Box>
);

export default Footer;